// SlicePlugin definition for the smiley slice (PRD-F3 §TR1, §T5.3).
//
// Uses the discriminated-union CapabilityDescriptor form (PRD-X §TR3).
// Declares exactly 5 capabilities — view-only `smiley-bitmap` (the
// bitmap-cache-driven renderer aspect), edit-only `resize`,
// view-only `anchor-target`, view-only `stack-presence`, and
// edit-only `updatable-properties`. Bewusst OHNE 'text-content',
// 'rotation', 'background-color', 'border-style', 'font-size',
// 'font-style', 'rich-edit', 'plain-edit' (FC4, FC5).
//
// `isAnchorTarget` returns true unconditionally per ND2.

import type { SlicePlugin } from '../../core/object-registry.js';
import {
  type CapabilityDescriptor,
  SMILEY_BITMAP_VIEW,
  RESIZE_EDIT,
  ANCHOR_TARGET_VIEW,
  STACK_PRESENCE_VIEW,
  UPDATABLE_PROPERTIES_EDIT,
} from '../../core/capabilities/capability.interface.js';
import type { SmileyObject } from './smiley.interface.js';
import { createSmileyDefaults } from './smiley-defaults.factory.js';
import { createNode, updateNode } from './smiley.renderer.js';

const SMILEY_CAPABILITIES: readonly CapabilityDescriptor[] = [
  { capability: 'smiley-bitmap', view: SMILEY_BITMAP_VIEW },
  { capability: 'resize', edit: RESIZE_EDIT },
  { capability: 'anchor-target', view: ANCHOR_TARGET_VIEW },
  { capability: 'stack-presence', view: STACK_PRESENCE_VIEW },
  { capability: 'updatable-properties', edit: UPDATABLE_PROPERTIES_EDIT },
];

export const smileySlice: SlicePlugin<SmileyObject> = {
  type: 'smiley',
  role: 'primary',
  capabilities: SMILEY_CAPABILITIES,
  display: {
    iconUrl: 'fa-face-smile',
    label: 'Smiley',
  },
  createDefaults: createSmileyDefaults,
  createNode,
  updateNode,
  isAnchorTarget: () => true,
};
